export default __webpack_public_path__ + "static/media/cds.a7209bf0.png";